import Cookies from "js-cookie";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

import { useTranslation } from "react-i18next";
import {
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
  ViberShareButton,
} from "react-share";

const SharePost = ({
  postUrl,
  postHeader,
  imageUrl,
  description,
  typeShare,
}) => {
  const { t } = useTranslation();
  const i18n = Cookies.get("i18nextLng");
  useEffect(() => {
    document.title = postHeader;

    const descriptionMetaTag = document.querySelector(
      'meta[name="description"]'
    );
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", description);
    }

    const imageMetaTag = document.querySelector('meta[property="og:image"]');
    if (imageMetaTag) {
      imageMetaTag.setAttribute("content", imageUrl);
    }

    const ogTitleMetaTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleMetaTag) {
      ogTitleMetaTag.setAttribute("content", postHeader);
    }
  }, [description, imageUrl, postHeader]);

  return (
    <div className="flex">
      <span className={`${i18n}`}>{t("shareOnSocialMedia")} : </span>
      <Helmet>
        <meta name="og:title" content={postHeader} />
        <meta name="og:description" content={description} />
        <meta name="og:image" content={imageUrl} />
      </Helmet>
      {/* <Helmet>
          <meta property="og:url" content={postUrl} />
          <meta property="og:title" content={postHeader} />
          <meta property="title" content={postHeader} />
          <meta property="og:image" content={imageUrl} href={imageUrl} />
          <meta property="image" content={imageUrl} href={imageUrl} />
          <meta property="og:description" content={description} />
          <meta property="url" content={postUrl} />
          <meta property="title" content={postHeader} />
          <meta property="image" content={imageUrl} href={imageUrl} />
          <meta property="description" content={description} />
        </Helmet> */}
      <span className="flex space-x-1">
        <a
          className="inline"

          // https://db.vibrance.group/GenaralShares/Index?title=title&description&redirectUrl=https%3A%2F%2Fvarypharmacy.com%2Fshop%2Fproduct%2FCfDJ8FFrzvg6Z0tFiUNXbfAvsJTdXYA-TRLewm50xNt808moYtp9pxj5anGCkI0uQmLWsDx-TN5fvI2UUn8cLazFLpz2e7xlCJBeMiRzqBTUnJCiP7acOz2Hc8GRRtV-kfOr-w&imagePath=https%3A%2F%2Fvarypharmacy.com%2Fapi%2FImages%2FProductImages%2Fc33a8db7-7029-43aa-8f1b-3c56e7db8c67.jpg&typeShare=Facebook&fbclid=IwAR13HxZojQ4dHzZ6WP-_ic1_01Wf4IeqYdBHpReGm0OBhHpCJZ99YIm8bVU
          href={`https://postshares.stacksolvers.com/Test/Index?title=${encodeURIComponent(
            postHeader
          )}&description=${encodeURIComponent(
             
          )}&redirectUrl=${encodeURIComponent(
            "https://varypharmacy.com/shop/product/CfDJ8FFrzvg6Z0tFiUNXbfAvsJSmiYIvmNCeNP-VLZknYS0eZr7AltbP4zPFLG8bDOOcSUBjYqQlcLjrmZDmZNgEKiC_atl-sOynBDg6ZRsp0Fja9OQE9Qjgm4dd0Bp4OJ0lCg"
          )}&imagePath=${encodeURIComponent(
            imageUrl
          )}&typeShare=${encodeURIComponent("Facebook")}`}
          target="_blank"
          rel="noreferrer"
          url={"https://postshares.stacksolvers.com/Test/Index?title=%D8%B4%D8%A7%D9%85%D9%BE%DB%86%DB%8C%20%D8%A8%DB%95%D9%87%DB%8E%D8%B2%DA%A9%D8%B1%D8%AF%D9%86%DB%8C%20%D9%82%DA%98%D8%A8%D8%B1%D8%A7%D9%86%D8%AF%DB%8C%20%D9%84%D8%A7%D9%84%D9%88%DA%A9%D8%B3%DB%8C%20%D9%81%DB%95%DA%95%DB%95%D9%86%D8%B3%DB%8C&description=undefined&redirectUrl=https%3A%2F%2Fvarypharmacy.com%2Fshop%2Fproduct%2FCfDJ8FFrzvg6Z0tFiUNXbfAvsJSmiYIvmNCeNP-VLZknYS0eZr7AltbP4zPFLG8bDOOcSUBjYqQlcLjrmZDmZNgEKiC_atl-sOynBDg6ZRsp0Fja9OQE9Qjgm4dd0Bp4OJ0lCg&imagePath=https%3A%2F%2Fvarypharmacy.com%2Fapi%2FImages%2FProductImages%2F6b899401-f1c9-4911-891c-da0905e23928.jpg&typeShare=Facebook"}
          title={postHeader}
          hashtag="#vary"
        >
          <svg
            aria-hidden="true"
            focusable="false" 
            data-prefix="fab"
            data-icon="facebook-f"
            className="inline text-blue-500 duration-500 group-hover:scale-105"
            role="img"
            width="20"
            height="20"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
          >
            <path
              fill="currentColor"
              d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
            ></path>
          </svg>
        </a>
        <TelegramShareButton
          className="inline"
          // href={`https://db.vibrance.group/GeneralShares/Index?title=${encodeURIComponent(
          //   postHeader
          // )}&description=${encodeURIComponent(
          //   description
          // )}&redirectUrl=${encodeURIComponent(
          //   postUrl
          // )}&imagePath=${encodeURIComponent(
          //   imageUrl
          // )}&typeShare=${encodeURIComponent("Telegram")}`}
          // target="_blank"
          // rel="noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="duration-500 bi bi-telegram group-hover:scale-105 text-cyan-500"
            viewBox="0 0 16 16"
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
          </svg>
        </TelegramShareButton>
        {/* <span>
          <TwitterShareButton url={postUrl} title={postHeader}>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="twitter"
              className="duration-500 group-hover:scale-105"
              role="img"
              width="20"
              height="20"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M459.37 151.94c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.555-298.555 298.555-59.435 0-114.44-17.233-160.839-47.086 8.453.974 16.547 1.299 25.218 1.299 49.004 0 94.024-16.265 130.339-43.779-46.074-.866-84.877-31.097-98.108-72.512 6.463 .974 12.925 1.624 19.712 1.624 9.547 0 18.894-1.299 27.765-3.649-48.056-9.697-84.377-52.118-84.377-102.568v-1.299c13.645 7.297 29.39 11.946 45.761 12.27-26.265-17.232-43.13-46.073-43.13-78.273 0-17.882 4.573-34.27 12.92-48.056 47.086 57.43 117.484 95.09 196.74 99.786-1.624-7.297-2.598-14.27-2.598-21.92 0-52.767 42.545-95.09 95.09-95.09 27.44 0 52.118 11.297 69.657 29.064 21.27-4.248 41.565-12.27 59.715-23.767-7.946 21.92-24.49 40.944-46.72 52.118 21.595-2.924 42.545-8.779 62.215-17.883-14.92 20.295-33.617 38.015-55.687 52.766z"
              ></path>
            </svg>
          </TwitterShareButton>
        </span>
        <a
          className="inline"
          href={`https://db.vibrance.group/GeneralShares/Index?title=${encodeURIComponent(
            postHeader
          )}&description=${encodeURIComponent(
            description
          )}&redirectUrl=${encodeURIComponent(
            postUrl
          )}&imagePath=${encodeURIComponent(
            imageUrl
          )}&typeShare=${encodeURIComponent("Viber")}`}
          target="_blank"
          rel="noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            className="text-indigo-500 duration-500 group-hover:scale-105"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M11.4 0C9.473.028 5.333.344 3.02 2.467C1.302 4.187.696 6.7.633 9.817C.57 12.933.488 18.776 6.12 20.36h.003l-.004 2.416s-.037.977.61 1.177c.777.242 1.234-.5 1.98-1.302c.407-.44.972-1.084 1.397-1.58c3.85.326 6.812-.416 7.15-.525c.776-.252 5.176-.816 5.892-6.657c.74-6.02-.36-9.83-2.34-11.546c-.596-.55-3.006-2.3-8.375-2.323c0 0-.395-.025-1.037-.017zm.058 1.693c.545-.004.88.017.88.017c4.542.02 6.717 1.388 7.222 1.846c1.675 1.435 2.53 4.868 1.906 9.897v.002c-.604 4.878-4.174 5.184-4.832 5.395c-.28.09-2.882.737-6.153.524c0 0-2.436 2.94-3.197 3.704c-.12.12-.26.167-.352.144c-.13-.033-.166-.188-.165-.414l.02-4.018c-4.762-1.32-4.485-6.292-4.43-8.895c.054-2.604.543-4.738 1.996-6.173c1.96-1.773 5.474-2.018 7.11-2.03zm.38 2.602a.304.304 0 0 0-.004.607c1.624.01 2.946.537 4.028 1.592c1.073 1.046 1.62 2.468 1.633 4.334c.002.167.14.3.307.3a.304.304 0 0 0 .3-.304c-.014-1.984-.618-3.596-1.816-4.764c-1.19-1.16-2.692-1.753-4.447-1.765zm-3.96.695a.981.981 0 0 0-.616.117l-.01.002c-.43.247-.816.562-1.146.932c-.002.004-.006.004-.008.008c-.267.323-.42.638-.46.948a.596.596 0 0 0-.007.14c0 .136.022.27.065.4l.013.01c.135.48.473 1.276 1.205 2.604c.42.768.903 1.5 1.446 2.186c.27.344.56.673.87.984l.132.132c.31.308.64.6.984.87a15.524 15.524 0 0 0 2.186 1.447c1.328.733 2.126 1.07 2.604 1.206l.01.014a1.275 1.275 0 0 0 .54.055c.31-.036.627-.19.948-.46c.004 0 .003-.002.008-.005c.37-.33.683-.72.93-1.148l.003-.01c.225-.432.15-.842-.18-1.12c-.004 0-.698-.58-1.037-.83c-.36-.255-.73-.492-1.113-.71c-.51-.285-1.032-.106-1.248.174l-.447.564c-.23.283-.657.246-.657.246c-3.12-.796-3.955-3.955-3.955-3.955s-.037-.426.248-.656l.563-.448c.277-.215.456-.737.17-1.248a12.73 12.73 0 0 0-.71-1.115a28.35 28.35 0 0 0-.83-1.035a.822.822 0 0 0-.502-.297zm4.49.88a.303.303 0 0 0-.018.606c1.16.085 2.017.466 2.645 1.15c.63.688.93 1.524.906 2.57a.306.306 0 0 0 .61.013c.025-1.175-.334-2.193-1.067-2.994c-.74-.81-1.777-1.253-3.05-1.346h-.024zm.463 1.63a.305.305 0 0 0-.3.287c-.008.167.12.31.288.32c.523.028.875.175 1.113.422c.24.245.388.62.416 1.164a.304.304 0 0 0 .605-.03c-.03-.644-.215-1.178-.58-1.557c-.367-.378-.893-.574-1.52-.607h-.018z"
            />
          </svg>
        </a> */}
      </span>
    </div>
  );
};

export default SharePost;
